export const PAGE_SIZE = 10;

export function paginate<T>(items: T[], page: number) {
  const start = (page - 1) * PAGE_SIZE;
  return items.slice(start, start + PAGE_SIZE);
}

export function calcPageCount<T>(items: T[]) {
  return Math.ceil(items.length / PAGE_SIZE);
}
